module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('client-list', {
    attrs: {
      "show-list-initially": false,
      "with-action": false,
      "with-create": false
    },
    on: {
      "relationshipselected": _vm.setRelationship
    },
    model: {
      value: (_vm.recipient),
      callback: function($$v) {
        _vm.recipient = $$v
      },
      expression: "recipient"
    }
  }), _vm._v(" "), (_vm.recipient) ? [(_vm.recipient.phone_number) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 0
      }
    }
  }, [_vm._v(_vm._s(_vm.recipient.phone_number))]) : _vm._e(), _vm._v(" "), (_vm.recipient.email) ? _c('v-chip', {
    staticClass: "v-chip--x-small ml-2",
    attrs: {
      "outline": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.recipient.email))]) : _vm._e(), _vm._v(" "), (_vm.recipientId) ? _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "disabled": !_vm.recipient.phone_number
    }
  }, [_vm._v("Short message")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "disabled": !_vm.recipient.email
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-textarea', {
    attrs: {
      "box": "",
      "label": "short message",
      "counter": "140"
    },
    model: {
      value: (_vm.shortMessage),
      callback: function($$v) {
        _vm.shortMessage = $$v
      },
      expression: "shortMessage"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('v-text-field', {
    attrs: {
      "label": "subject"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "box": "",
      "label": "message"
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("Send")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-336cd10a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/communications/Compose.vue
// module id = 1385
// module chunks = 9